import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./index.css"; // Your main CSS
import Header from "./header";
import Footer from "./Footer";
import Services from "./services";
import About from "./about";
import Customizations from "./customizations";
import Integrations from "./integrations";
import Utilities from "./utilities";
import WhyMe from "./why-me";
import Contact from "./contact";
import GameWrapper from "./GameWrapper";
import Pricing from "./pricing";
import SchemaVisualizer from "./schema-visualizer";

const App = () => {
  useEffect(() => {
    // Google Analytics
    function gtag() {
      window.dataLayer.push(arguments);
    }

    window.dataLayer = window.dataLayer || [];
    gtag("js", new Date());
    gtag("config", "AW-16528448767");
    gtag("event", "conversion", {
      send_to: "AW-16528448767/7yqeCM7l6KUZEP-5sMk9",
      value: 1.0,
      currency: "USD",
    });
  }, []);

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow">
        <Router>
          <Routes>
            <Route path="/" element={<Services />} />
            <Route path="/about" element={<About />} />
            <Route path="/why-me" element={<WhyMe />} />
            <Route path="/customizations" element={<Customizations />} />
            <Route path="/integrations" element={<Integrations />} />
            <Route path="/utilities" element={<Utilities />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/gamewrapper" element={<GameWrapper />} />
            <Route path="/schema-visualizer" element={<SchemaVisualizer />} />
          </Routes>
        </Router>

      </main>
      <Footer />
    </div>
  );
};

export default App;
